import {useEffect} from 'react';
import {FetchStatus} from '../../../../../../common/FetchStatus.enum';
import {useThunkDispatch} from '../../../../../../common/useThunkDispatch.hook';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {fetchTextViewerPreviewInfo} from '../util/fetchTextViewerPreviewInfo.thunk';

export function useFetchTextViewerPreview({
  previewKey,
  isProductId,
}: {
  previewKey: string;
  isProductId?: boolean;
}) {
  const fetchedData = useTypedSelector(
    state => state.viewerInfo.textViewerPreview[previewKey]
  );

  const dispatch = useThunkDispatch();

  const {fetchStatus, data} = fetchedData || {};

  useEffect(() => {
    dispatch(fetchTextViewerPreviewInfo({previewKey, isProductId}));
  }, [dispatch, isProductId, previewKey]);

  if (!fetchedData) {
    return {
      isLoading: true,
    };
  }

  return {
    isLoading:
      fetchStatus === FetchStatus.Idle || fetchStatus === FetchStatus.Loading,
    data,
  };
}
